import React, { useState, useEffect, useContext } from 'react';
import './navbar.scss';
import useTheme from '../../hooks/useTheme';
// import i18n from '../../localization/config';
// import { useLocation } from "react-router-dom";
import TimeComponent from '../../lib/TimeProvider/time';
import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import {
	Down,
	// BellIcon,
	// ThemeIcon,
	// HeaderHelpIcon,
	FlagIcon,
	UserProfileIcon,
	MoveToStaticIcon,
	// PrivacyPolicyIcon,
	// ActiveSession,
} from '../../assets/icons/index';
import { LogoBrandBlue } from '../../assets/images/index';
// import elevation from '../../token/global/elevation';
import { useDispatch } from 'react-redux';
import { logout } from '../../actions/userActions';
import AdvanceSearchBox from '../AdvanceSearchBox/AdvanceSearchBox';
// import LanguageSelector from '../language-selector/languageSelector';
import { useTranslation } from 'react-i18next';
import { TRIGGER_TOUR_GUIDE_MODAL } from '../../constants/tourGuideConstants';
import { Menu, MenuItem, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Tooltip from '../tooltip/Tooltip';
import { useSelector } from 'react-redux';
import AnnouncementBanner from '../announcementBanner/AnnouncementBanner';
import { listMaintenanceInstances } from '../../actions/maintenanceInstanceAction';
import { ThemeContext } from '../../lib/ThemeProvider';
import AlarmUpdate from '../alarmUpdate/alarmUpdates';
// import { getAdminDetails } from '../../actions/userActions';
import { CANVAS_UI_VERSION } from '../../constants/commonConstants';
import { devicesAlarmsCount } from '../../actions/maintenance/activeAlarmsActions';
// import { getSystemConfig } from '../../actions/licenseManagement/licenseActions';
import { getCookie } from '../../utils/cookieHelper';
import { getBannerZTPDetails } from '../../actions/bannerAction';
import { MYUSER_PERMISSION, VIEW_PERMISSION } from '../../constants/permissionConstants';
import { fetchPermission } from '../../utils/utility';
import { decryptData } from '../../utils/crypto';
import { RESET_ANNOUNCEMENT_BANNER_CLOSE } from '../../constants/maintenanceInstanceConstants';
import { AiChatModule } from '../aiChatModule';
import { AgentBridgeProvider } from '../../agentBridge';

const Navbar = () => {
	const { color, FontFace } = useTheme('LIGHT');
	const [isNavbarVisible, setIsNavbarVisible] = useState(true);
	const [isLogoutClick, setIsLogoutClick] = useState(false);
	localStorage.setItem("isLogoutClick", isLogoutClick);
	// const isLightTheme = color.background.primary === '#FFFFFF';
	const announcementBannerClose = useSelector(
		(state) => state.announcementBannerCloseTrigger.announcementBannerClose
	);
	// const [activeItem, setActiveItem] = useState("Home");
	// const [language, setLanguage] = useState('English');
	const dispatch = useDispatch();
	// const bannerDetails = useSelector((state) => state.bannerDetails);
	// const { adminDetails } = admindetailsGet;
	const devicesAlarmsCountData = useSelector((state) => state.devicesAlarmsCountReducer);
	console.log('devicesAlarmsCountData', devicesAlarmsCountData)
	const dashboardState = useSelector((state) => state.dashboard.dashboardState);
	const tourStep = useSelector((state) => state.tourGuideStep.tourStep);
	const [alarmIconClicked, setAlarmIconClicked] = useState(false);
	// useEffect(() => {
	// 	dispatch(getAdminDetails());
	// }, [dispatch]);
	const isLocked = useSelector((state) => state.sidebarLock.isLocked);

	const [anchorEl, setAnchorEl] = useState(null);
	const { setTheme } = useContext(ThemeContext);
	const userName = getCookie('userName') ? decryptData(getCookie('userName')) : 'Admin name';


	useEffect(() => {
		if (userName === 'Admin name') {
			dispatch(logout());
		}
	}, [userName, dispatch]);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const [headerLogo, setLogo] = useState(null);

	// useEffect(() => {
	// 	const fetchLogo = async () => {
	// 					console.log("addconfig3")
	// 	  try {
	// 		const systemConfig = await dispatch(getSystemConfig());
	// 		if (systemConfig && systemConfig.length > 0) {
	// 		  setLogo(systemConfig[0].upload_logo);
	// 		}
	// 	  } catch (error) {
	// 		console.error("Error fetching system config:", error);
	// 	  }
	// 	};

	// 	fetchLogo(); 
	//   }, [dispatch]); 
	useEffect(() => {
		dispatch(getBannerZTPDetails())
			.then((response) => {
				setLogo(response?.logo);
			})
			.catch((err) => {
				console.error('Failed to fetch ZTP details:', err);
			});
	}, [dispatch]);

	const handleClose = () => {
		setAnchorEl(null);
	};

	useEffect(() => {
		if (alarmIconClicked == true) {
			dispatch(devicesAlarmsCount());
		}
	}, [dispatch, alarmIconClicked])

	useEffect(() => {
		dispatch(devicesAlarmsCount());
	}, [])
	// 	useEffect(() => {
	// 	if (!apiCalledRef.current) {
	// 		dispatch(getBannerZTPDetails())
	// 			.then((response) => {
	// 				setLogo(response?.logo);
	// 			})
	// 			.catch((err) => {
	// 				console.error('Failed to fetch ZTP details:', err);
	// 			});
	// 		apiCalledRef.current = true;
	// 	}
	// }, [dispatch]);

	useEffect(() => {
		const theme = localStorage.getItem('theme');
		if (theme) {
			if (localStorage.getItem('theme') === 'light') {
				setTheme('LIGHT');
			} else {
				setTheme('DARK');
			}
		} else {
			localStorage.setItem('theme', 'light');
		}
	}, []);

	//   const handleThemeClick = () => {
	// 	if(localStorage.getItem('theme') === 'light'){
	// 		setTheme('DARK');
	// 		localStorage.setItem('theme','dark');
	// 	}else{
	// 		setTheme('LIGHT');
	// 		localStorage.setItem('theme','light');

	// 	}
	//   };
	const navigate = useNavigate();

	// const { t } = useTranslation();
	// const onMenuItemClick = (e) => {
	//   setActiveItem(e.target.text);
	// };

	// const languageChange = (event) => {
	//   setLanguage(event.target.value);
	// };
	// const languageOptions = [
	//   { key: "English", text: "English", value: "English" },
	//   { key: "Russian", text: "Russian", value: "Russian" },
	//   { key: "Spanish", text: "Spanish", value: "Spanish" },
	// ];
	// const languageCodes = {
	// 	English: 'en',
	// 	Spanish: 'es',
	// 	Russian: 'ru',
	// };
	// const location = useLocation();
	// useEffect(() => {
	// 	i18n.changeLanguage(languageCodes[language]);
	// 	localStorage.setItem('lang', languageCodes[language]);
	// }, [language]);

	useEffect(() => { }, []);

	const [dropdownState, setDropdownState] = useState(false);
	// const [dropdownValue, setDropdownValue] = useState('');

	const handleDropdownClick = (event) => {
		setDropdownState(!dropdownState);
		// setDropdownValue(''); // TODO
		handleClick(event);
		// setLanguage('English'); // TODO
	};
	// const handleSetDropdownValue = (value) => {
	//   setDropdownValue(value);
	//   setDropdownState(!dropdownState);
	// };
	// const handleDropdownClickk = () => {
	// 	setDropdownState(!dropdownState)
	// 	setDropdownValue(''); // TODO
	// 	// setLanguage('English'); // TODO
	// };
	const hideNavbar = () => {
		setIsNavbarVisible(false);
		// setTimeout(() => {
		//   setIsNavbarVisible(true); // Show navbar after 3 seconds
		// }, 3000); // Adjust the duration based on your needs
	};

	const logoutClick = () => {
		setIsLogoutClick(true);
		dispatch(logout(navigate, hideNavbar));

	};

	const handleTourGuideTrigger = () => {
		if (isLocked) return;
		navigate('dashboard');
		setDropdownState(!dropdownState);
		setAnchorEl(null);

		// Scroll both window and dashboard container to top
		setTimeout(() => {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});

			const dashboardScrollContainer =
				document.querySelector('[style*="overflowY: auto"]') ||
				document.querySelector('[style*="overflow-y: auto"]') ||
				document.querySelector('.DashboardWrapper') ||
				document.querySelector('[data-testid="dashboard-scroll"]');

			if (dashboardScrollContainer) {
				dashboardScrollContainer.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth',
				});
			}
		}, 200);

		dispatch({ type: TRIGGER_TOUR_GUIDE_MODAL, payload: true });
	};

	// ----- HFCL Chat Bot integration ---------------------------------------
	// Expose the tour-trigger on `window` so the chat's pseudo-action
	// runner can fire it without coupling to navbar internals. The
	// handler closes over `dispatch`, `navigate`, and `isLocked` — refs
	// would normally be needed, but since navbar mounts once for the
	// whole authenticated app the closure is stable enough.
	useEffect(() => {
		if (typeof window === 'undefined') return undefined;
		const start = () => handleTourGuideTrigger();
		window.hfclStartTour = start;
		return () => {
			if (window.hfclStartTour === start) delete window.hfclStartTour;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLocked]);

	const handleProfileClick = (link) => {
		setDropdownState(!dropdownState);
		setAnchorEl(null);

		navigate('profile');
	};

	// const handlePasswordClick = (link) => {
	// 	setDropdownState(!dropdownState);
	// 	setAnchorEl(null);

	// 	navigate('manage-password');
	// };

	const { t } = useTranslation();
	const canViewAccount = fetchPermission(MYUSER_PERMISSION, VIEW_PERMISSION);


	const accountMenuItems = [
		...(canViewAccount
			? [
				{
					title: t('Account Details'),
					action: handleProfileClick,
					icon: UserProfileIcon,
				},
			]
			: []),
		{
			title: t('take_a_tour'),
			action: handleTourGuideTrigger,
			icon: FlagIcon,
			disabled: isLocked,
		},
		// {
		// 	title: 'Theme',
		// 	action: handleThemeClick,
		// 	icon: ThemeIcon,
		// },isNavbarVisible
		// {
		// 	title: t('password_n_2fa'),
		// 	action: handlePasswordClick,
		// 	icon: PrivacyPolicyIcon,
		// },
		{
			title: t('logout'),
			action: logoutClick,
			color: '#ef4444',
			icon: MoveToStaticIcon,
		}
	];

	useEffect(() => {
		dispatch(listMaintenanceInstances(5, 0));
	}, [dispatch]);

	useEffect(() => {
		if (tourStep >= 0) {
			setDropdownState(false);
			setAnchorEl(null);
		}
	}, [tourStep]);

	const maintenanceInstances = useSelector(
		(state) => state.maintenanceInstanceList.maintenanceInstances
	);
	const msg = maintenanceInstances?.data?.notification_msg;
	const pathname = window.location.pathname;

	useEffect(() => {
		if (msg) {
			dispatch({ type: RESET_ANNOUNCEMENT_BANNER_CLOSE });
		}
		}, [msg, dispatch]);

	return (
		<>
			{msg && !announcementBannerClose && pathname !== '/' && pathname !== '/signup' && pathname !== '/reset/password' && pathname !== '/signin/otpverify' && pathname !== '/license/upload' && (
				<AnnouncementBanner description={msg} />
			)}
			{isNavbarVisible && (
				<nav
					className="flex flex-between flex-middle pt-12 pb-12"
					style={{
						fontSize: FontFace.font_size.small,
						backgroundColor: color.background.primary,
						color: color.background.brand,
						border: `solid 1px ${color.button.secondary}`,
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						paddingLeft: '24px',
						paddingRight: '24px',
						zIndex: (tourStep === 2 || tourStep === 3) ? 3000 : 1300,
						marginTop:
							(msg && !announcementBannerClose) > 0 ? '32px' : '0px',
						pointerEvents: (tourStep === 2 || tourStep === 3) ? 'none' : 'auto',
					}}
				>
					<div className='header-container' style={{
						opacity: (tourStep === 2 || tourStep === 3) ? 0.5 : 1,
						color: (tourStep === 2 || tourStep === 3) ? '#999' : 'inherit',
					}}>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '4px',
							}}
						>
							{headerLogo ? (
								<img src={headerLogo} alt="Brand Logo" width="126px" height="39px" />
							) : (
								<LogoBrandBlue width="126px" height="39px" />
							)}
							<span style={{ marginTop: "12px" }}>({CANVAS_UI_VERSION})</span>
						</div>
						<div
							style={{
								fontSize: '20px',
								color: color.text.hyperlink,
								display: 'flex',
								alignItems: 'center'
							}}
						>
							{dashboardState && dashboardState !== 'disabled' && <span>{dashboardState}</span>}

						</div>
					</div>
					<div className='right-container'>
						<ul className="flex flex-between flex-middle links-container">
							{/* <div
					className="input-wrapper pt-8 pr-12 pb-8 pl-8"
					style={{
						textIndent: '10px',
						border: `2px solid ${color.input.line}`,
						backgroundColor: color.background.primary,
					}} */}
							{/* > */}
							{/* <button
					onClick={handleTourGuideTrigger}
					style={{ padding: '5px 5px' }}
				>
					Take a Tour
				</button> */}



							{/* <div
						style={{
							fontSize: '20px',
							color: '#000000',
							marginLeft: '4px',
						}}
					>
						
					</div> */}

							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: '12px',
									opacity: tourStep === 3 ? 1 : tourStep === 2 ? 0.5 : 1,
									pointerEvents:
										tourStep === 3 ? 'auto' : tourStep === 2 ? 'none' : 'auto',
									position: 'relative',
									zIndex: tourStep === 3 ? 3001 : 'auto',
								}}
							>
								<AgentBridgeProvider>
									<AiChatModule />
								</AgentBridgeProvider>
								<AdvanceSearchBox />
							</div>
							<ul className="flex flex-between flex-middle icon-container" style={{
								opacity: (tourStep === 2 || tourStep === 3) ? 0.5 : 1,
								pointerEvents: (tourStep === 2 || tourStep === 3) ? 'none' : 'auto',
							}}>
								{/* <span
							className="flex flex-middle "
							style={{ textIndent: '10px' }}
						>
							<SearchIcon width="16" height="16" />
						</span>
						<input
							className="search-input pl-10"
							type="text"
							placeholder="Search in io Canvas"
						/> */}
								{/* </div> */}
								<li
									className="time flex flex-right flex-row"
									style={{
										color: tourStep === 3 ? '#999' : color.text.primary,
										fontSize: FontFace.font_size.xx_small,
									}}
								>
									<TimeComponent />
								</li>
								{/* <li className="link"> */}
								{/* <Tooltip
						content={'Select your preferred language'}
						type="header"
						direction="bottom"
						delay={200}
						style  = {{width : 'auto'}}
					> */}
								{/* <div className="icon-badge-group">
							<div className="icon-badge-container" style={{marginTop: '3px'}}>
								<NavLinkButton tooltipText = {'Select your preferred language'} isFill = {true} color = {color} Icon = {LanguageSelector} /> */}
								{/* <LanguageSelector
									// className="icon-badge-icon"
									width="24px"
									height="24px"
								/> */}
								{/* </div> */}
								{/* </div> */}
								{/* </Tooltip> */}
								{/* </li> */}
								{/* <li className="link">
						<div className="icon-badge-group">
							<div className="icon-badge-container" style={{marginTop: '4px'}}>
								<NavLinkButton tooltipText = {"Active sessions"} color = {color} Icon = {ActiveSession} /> */}
								{/* <ActiveSession
									// className="icon-badge-icon"
									width="24px"
									height="24px"
									stroke={color.icon.primary}
								/> */}
								{/* </div>
						</div>
					</li> */}
								{/* <li className="link">
						<div className="icon-badge-group">
							<div className="icon-badge-container" style={{marginTop: '4px'}}> */}
								{/* <BellIcon
									// className="icon-badge-icon"
									width="24px"
									height="24px"
									stroke={color.icon.primary}
								/> */}
								{/* <NavLinkButton tooltipText = {"Notification"} color = {color} Icon = {BellIcon} />
								<div
									className="icon-badge flex flex-center flex-middle"
									style={{
										backgroundColor: color.alert.text_error,
										fontSize: FontFace.font_size.xx_inputlabel,
										border: `1px solid ${color.background.primary}`,
										color: color.background.primary,
									}}
								>
									<span className="badgetext">6</span>
								</div>
							</div>
						</div>
					</li> */}
								<li className="link"
									style={{
										pointerEvents: isLocked ? 'none' : 'auto', // disables all clicks
									}}>
									{/*
									 * Hidden launcher for the HFCL Chat Bot — clicking the bell
									 * is wrapped in <NavLinkButton>'s inner button, which
									 * makes querying it from outside fragile. We expose a
									 * tiny invisible <button> with `data-chat-action` so the
									 * chat's clickWhenReady can find a stable target. The
									 * onClick toggles the same alarm popover state as the
									 * real bell.
									 */}
									<button
										type="button"
										data-chat-action="navbar-alarm-summary"
										aria-hidden="true"
										tabIndex={-1}
										onClick={() => setAlarmIconClicked(!alarmIconClicked)}
										style={{
											position: 'absolute',
											width: 1,
											height: 1,
											padding: 0,
											margin: -1,
											overflow: 'hidden',
											clip: 'rect(0 0 0 0)',
											whiteSpace: 'nowrap',
											border: 0,
											background: 'transparent',
										}}
									/>
									<div className="icon-badge-group">
										<div
											className="icon-badge-container"
											style={{ marginTop: '3px' }}
										>
											<NavLinkButton
												tooltipText={'Alarm Summary'}
												isFill={true}
												color={color}
												Icon={AlarmUpdate}
												onClick={() => {
													setAlarmIconClicked(!alarmIconClicked)
												}}
											/>
											{/* <AlarmUpdate
									stroke={color.icon.primary} 
									width="24px"
									height="24px" 
								/> */}
											<div
												className="icon-badge flex flex-center flex-middle"
												style={{
													backgroundColor: color.alert.text_error,
													fontSize: FontFace.font_size.xx_inputlabel,
													border: `1px solid ${color.background.primary}`,
													color: color.background.primary,
													// width:'45px',
												}}
											>
												<span className="badgetext">{devicesAlarmsCountData?.alarmsCount?.data?.Critical < 1000 ? devicesAlarmsCountData?.alarmsCount?.data?.Critical : (devicesAlarmsCountData?.alarmsCount?.data?.Critical === 0 || null || undefined) ? '0' : '999+'}</span>
											</div>
										</div>
									</div>
								</li>
								{/* <li
						className="link"
						style={{ border: 'border: solid 2px #545454' }}>
						<div className="icon-badge-group">
							<div className="icon-badge-container" style={{marginTop: '3px'}}>
								<NavLinkButton  tooltipText = {"Helper"}color = {color} Icon = {HeaderHelpIcon} /> */}
								{/* <HeaderHelpIcon
									// className="icon-badge-icon"
									width="24px"
									height="24px"
									style={{stroke: color.icon.primary}}
								/> */}
								{/* </div>
						</div>
					</li> */}
								<li className="link pr-0">
									<div
										className={`dropdown`}
										style={{
											fontSize: FontFace.font_size.x_small,
											color: color.text.primary,
										}}
									>
										<button
											onClick={handleDropdownClick}
											className="dropdown-btn"
											style={{
												fontSize: FontFace.font_size.x_small,
												color: color.text.primary,
												marginRight: '-10px',
												marginLeft: '3px',
											}}
										>
											{userName}
											&nbsp;&nbsp;
											<Down
												className="downicon"
												style={{
													verticalAlign: 'middle',
													stroke: color.icon.primary,
												}}
											/>
										</button>
										<Menu
											anchorEl={anchorEl}
											keepMounted
											open={Boolean(anchorEl)}
											onClose={handleClose}
											style={{ marginRight: '24px' }}
										>
											{accountMenuItems.map(
												(accountMenuItem, index) => (
													<MenuItem
														key={index}
														onClick={() => {
															if (accountMenuItem.disabled) return;
															accountMenuItem.action();
														}}
														disabled={accountMenuItem.disabled}
													>
														<div
															style={{
																display: 'flex',
																flexDirection: 'row',
																alignItems: 'center',
															}}
														>
															<accountMenuItem.icon
																width={'16px'}
																height={'16px'}
																style={{
																	marginLeft: '-5px',
																	marginRight:
																		'-10px',
																}}
															/>
															<div
																style={{
																	width: '20px',
																}}
															/>
															<Typography
																color={
																	accountMenuItem.color
																}
																fontFamily={
																	'Inter-Regular'
																}
																fontSize={
																	FontFace.font_size
																		.input_text
																}
																sx={{
																	display: 'flex',
																	alignItems:
																		'center',
																	height: '17px',
																}}
															>
																{accountMenuItem.title}
																{accountMenuItem.title ===
																	'Theme' && (
																		<>
																			<div className="circle-container">
																				<div
																					className="theme-circle"
																					style={{
																						backgroundColor:
																							color
																								.icon
																								.brand,
																					}}
																				></div>
																				<div
																					className="theme-circle"
																					style={{
																						backgroundColor:
																							'#1a73e8',
																					}}
																				></div>
																			</div>
																		</>
																	)}
															</Typography>
														</div>
													</MenuItem>
												)
											)}
										</Menu>
										{/* <div
								style={{
									fontSize: FontFace.font_size.x_small,
									color: color.text.primary,
									backgroundColor:
										color.background.secondary_text,
									boxShadow: elevation.shadow4,
								}}
								className={`dropdown-items ${
									dropdownState ? 'isVisible' : 'isHidden'
								}`}
							>
								<div className="dropdown-item"></div>
								<div className="dropdown-item">
									<div
										className="dropdown__link"
										onClick={handleProfileClick}
									>
										{t('profile')}
									</div>
								</div>
								<div className="dropdown-item">
									<div
										className="dropdown__link"
										onClick={logoutClick}
									>
										{}
									</div>
								</div>
							</div> */}
									</div>
								</li>
							</ul>
						</ul>
					</div>
					<div className="hamburger">
						<span className="line"></span>
						<span className="line"></span>
						<span className="line"></span>
					</div>
				</nav>
			)}
		</>
	);
};

export default Navbar;

const NavLinkButton = ({
	Icon = null,
	color,
	isFill = false,
	tooltipText = '',
	onClick,
}) => {
	const [hideTooltip, setHideTooltip] = useState(false);
	console.log('hidetooltip=====', hideTooltip);

	return (
		<>
			<Tooltip
				content={tooltipText}
				type="basic"
				direction="bottom"
				offset={-1}
				style={{ width: 'auto' }}
				hideTooltip={hideTooltip}
			>
				<IconButton
					disableTouchRipple
					key={tooltipText}
					onClick={onClick}
					sx={{
						padding: '4px',
						borderRadius: '4px',
						width: '30px',
						height: '30px',
						border: 'none',
						'&:hover': {
							backgroundColor: color.button.primary_outline_hover,
						},
						'&:hover svg': {
							stroke: !isFill && color.icon.brand,
							fill: isFill && color.icon.brand,
						},
						'& .MuiTouchRipple-root': {
							color: color.button.primary,
						},
						'& .MuiTouchRipple-root .MuiTouchRipple-child': {
							borderRadius: '4px',
						},
					}}
				>
					{Icon && isFill && (
						<Icon
							fill={color.icon.primary}
							style={{ width: '24px', height: '24px' }}
							setHideTooltip={setHideTooltip}
						/>
					)}
					{Icon && !isFill && (
						<Icon
							stroke={color.icon.primary}
							style={{ width: '24px', height: '24px' }}
							setHideTooltip={setHideTooltip}
						/>
					)}
				</IconButton>
			</Tooltip>
		</>
	);
};

NavLinkButton.propTypes = {
	Icon: PropTypes.string,
	color: PropTypes.object.isRequired,
	isFill: PropTypes.bool,
	tooltipText: PropTypes.string,
	onClick: PropTypes.func,
};
